export default __webpack_public_path__ + "circle.659c9593.gif";